/**
 * Original from: https://stackoverflow.com/questions/21961839/simulation-background-size-cover-in-canvas
 * Original By Ken Fyrstenberg Nilsen
 *
 * Note: img must be fully loaded or have correct width & height set.
 */
interface DrawImagePropArgs {
  ctx: CanvasRenderingContext2D;
  img: HTMLImageElement | HTMLCanvasElement | HTMLVideoElement;
  x?: number;
  y?: number;
  w?: number;
  h?: number;
  offsetX?: number;
  offsetY?: number;
}

export default function drawImageProp({
  ctx,
  img,
  x,
  y,
  w,
  h,
  offsetX,
  offsetY,
}: DrawImagePropArgs): void {
  // Defaults
  if (typeof x !== "number") x = 0;
  if (typeof y !== "number") y = 0;
  if (typeof w !== "number") w = ctx.canvas.width;
  if (typeof h !== "number") h = ctx.canvas.height;
  if (typeof offsetX !== "number") offsetX = 0.5;
  if (typeof offsetY !== "number") offsetY = 0.5;

  // keep bounds [0.0, 1.0]
  if (offsetX < 0) offsetX = 0;
  if (offsetY < 0) offsetY = 0;
  if (offsetX > 1) offsetX = 1;
  if (offsetY > 1) offsetY = 1;

  const iw = img.width as number,
    ih = img.height as number,
    r = Math.min(w / iw, h / ih),
    nw = iw * r, // new prop. width
    nh = ih * r, // new prop. height
    ar = 1;

  let _nw = nw;
  let _nh = nh;
  let _ar = ar;

  // decide which gap to fill
  if (_nw < w) _ar = w / _nw;
  if (Math.abs(_ar - 1) < 1e-14 && _nh < h) _ar = h / _nh; // updated
  _nw *= _ar;
  _nh *= _ar;

  // calc source rectangle
  const cw = iw / (_nw / w);
  const ch = ih / (_nh / h);

  let cx = (iw - cw) * offsetX;
  let cy = (ih - ch) * offsetY;

  // make sure source rectangle is valid
  if (cx < 0) cx = 0;
  if (cy < 0) cy = 0;
  let _cw = cw;
  let _ch = ch;
  if (_cw > iw) _cw = iw;
  if (_ch > ih) _ch = ih;

  // fill image in dest. rectangle
  ctx.drawImage(img, cx, cy, _cw, _ch, x, y, w, h);
}